export const NetoyageData = [
  {
    id: 1,
    image: require("../assets/images/netoyage/b70.webp"),
    title: "Balayeuse",
    products: [
      {
        id: 1,
        name: "Flipper+",
        description: "",
        descriptionPoints: [
          {
            description:
              "Flipper+ est une balayeuse manuelle pour un excellent balayage manuel.",
          },
          {
            description:
              "Trémie à poussière robuste, sans rouille, légère et robuste.",
          },
          {
            description:
              "Incorporé avec une nouvelle technologie anti-enroulement innovante qui facilite le nettoyage.",
          },
          {
            description:
              "Poignée ergonomique avec réglage en hauteur pour s'adapter à la taille de l'opérateur.",
          },
          {
            description:
              "Les brosses en deux parties nouvellement conçues garantissent un remplacement facile, si nécessaire.",
          },
          {
            description: "Performances de balayage jusqu'à 2600 m² par heure.",
          },
          { description: "Convient à la fois à l'intérieur et à l'extérieur" },
        ],
        image: require("../assets/images/netoyage/flipper.webp"),
        images: [
          {
            image: require("../assets/images/netoyage/flipper.webp"),
          },
          {
            image: require("../assets/images/netoyage/flipper2.webp"),
          },
        ],
        video: "https://www.youtube.com/embed/kUzVwtPVxtQ", //NOTE: l vid lezmek tekhdou mel youtube => iframe
        ficheTechnique: [
          { key: "Largeur de balayage (avec balai latéral)", value: "650 mm" },
          { key: "Largeur de balayage (sans balai latéral)", value: "460 mm" },
          { key: "Zone de couverture théorique", value: "2600m²/h" },
        ],
        brochure: require("../assets/brochure/flipper.pdf"),
        technicalFeatures: [
          {
            id: 1,
            type: "Spécifications",
            features:[
          { key: "Largeur de balayage (avec balai latéral)", value: "650 mm" },
          { key: "Largeur de balayage (sans balai latéral)", value: "460 mm" },
          { key: "Zone de couverture théorique", value: "2600m²/h" },
          { key: "Capacité de la trémie de saleté", value: "40L" },
          { key: "Longueur (sans/avec balai latéral)", value: "800/1000mm" },
          { key: "Largeur (sans/avec balai latéral)", value: "725/785mm" },
          { key: "Hauteur (sans/avec poignée)", value: "400/1020mm" },
          { key: "Masse", value: "23.5 kg" },
        ],
      }]
      },
      {
        id: 2,
        name: "Roots Sweep B70",
        description:
          "Roots Sweep B70 est une balayeuse aspirante à batterie avec traction. Remplissage maximal de la trémie grâce au principe aérien. La grande brosse latérale permet un balayage efficace lors de la négociation des coins. Grande trappe à débris pour recueillir également les gros débris. Rendement de surface jusqu'à 3525 m2/h.",
        descriptionPoints: [
          {
            description:
              "Grande maniabilité, grandes roues en caoutchouc non marquantes",
          },
          {
            description:
              "Balayage optimal même dans les virages grâce au balai latéral",
          },
          { description: "Nettoyage facile des allées et des coins" },
          {
            description:
              "Entraînement de traction intégré pour un fonctionnement sans stress",
          },
          { description: "Système de filtration d'air de haute qualité" },
        ],
        image: require("../assets/images/netoyage/b70.webp"),
        images: [
          {
            image: require("../assets/images/netoyage/b70.webp"),
          },
          {
            image: require("../assets/images/netoyage/b70-2.webp"),
          },
        ],
        video: "https://www.youtube.com/embed/9DVtUOiZvX8", //NOTE: l vid lezmek tekhdou mel youtube => iframe
        ficheTechnique: [
          {
            key: "Largeur de balayage (sans balai latéral)",
            value: "500 millimètres",
          },
          {
            key: "Largeur de balayage (avec balai latéral)",
            value: "700 millimètres",
          },
          {
            key: "Couverture de surface théorique avec un balai latéral",
            value: "3525 m2 / h",
          },
        ],
        brochure: require("../assets/brochure/b70.pdf"),
        technicalFeatures: [
          {
            id: 1,
            type: "Spécifications",
            features:[
          {
            key: "Largeur de balayage (sans balai latéral)",
            value: "500 millimètres",
          },
          {
            key: "Largeur de balayage (avec balai latéral)",
            value: "700 millimètres",
          },
          {
            key: "Couverture de surface théorique avec un balai latéral",
            value: "3525 m2 / h",
          },
          { key: "Zone de filtre", value: "1,6 m2" },
          { key: "Pouvoir total", value: "550W" },
          { key: "Capacité de la trémie à poussière", value: "35L" },
          { key: "Vitesse de travail", value: "5km/h" },
          { key: "Évaluation de la batterie", value: "24/36 V/A" },
          { key: "Dimensions (L x l x H)", value: "1300 x 810 x 680 mm" },
          { key: "Poids, prêt à fonctionner", value: "135 kilogrammes" },
        ],
          }]
      },
      {
        id: 3,
        name: "Roots Sweep RB100",
        description: "",
        descriptionPoints: [
          {
            description:
              "Roots Sweep RB100 est une balayeuse autoportée de taille moyenne conçue pour nettoyer les passages étroits et même les zones encombrées avec agilité.",
          },
          { description: "Rentable et facile à entretenir." },
          {
            description:
              "Grâce à la construction solide et fiable, les industries à usage moyen sont prises en charge.",
          },
          {
            description:
              "Conçu pour une utilisation à l'intérieur et à l'extérieur et sur plusieurs surfaces, y compris les sols durs industriels, les surfaces époxy et carrelées.",
          },
          {
            description:
              "Une plus grande visibilité du travail permet une utilisation facile",
          },
          {
            description:
              "Rayon de braquage faible - 180 cm, plus grande maniabilité.",
          },
        ],
        image: require("../assets/images/netoyage/rb100.webp"),
        images: [
          {
            image: require("../assets/images/netoyage/rb100.webp"),
          },
          {
            image: require("../assets/images/netoyage/rb100-2.webp"),
          },
        ],
        video: "https://www.youtube.com/embed/RA-hTnw--Lg", //NOTE: l vid lezmek tekhdou mel youtube => iframe
        ficheTechnique: [
          {
            key: "Largeur de balayage avec un balai latéral",
            value: "1000 millimètres",
          },
          { key: "Largeur du balai principal", value: "750 millimètres" },
          {
            key: "Couverture de surface théorique avec un balai latéral",
            value: "6500 m2 / h",
          },
        ],
        brochure: require("../assets/brochure/rb100.pdf"),
        technicalFeatures: [
          {
            id: 1,
            type: "Spécifications",
            features:[          {
              key: "Largeur de balayage avec un balai latéral",
              value: "1000 millimètres",
            },
            { key: "Largeur du balai principal", value: "750 millimètres" },
            {
              key: "Couverture de surface théorique avec un balai latéral",
              value: "6500 m2 / h",
            },
            { key: "Zone de filtre", value: "3 m2" },
            {
              key: "Puissance totale / Puissance du moteur d'entraînement",
              value: "1750/800W",
            },
            { key: "Capacité de la trémie à poussière", value: "2x40L" },
            { key: "Vitesse de travail", value: "6.5km/h" },
            { key: "Évaluation de la batterie", value: "4 x 6/200 V/Ah" },
            { key: "Dimensions (L x l x H)", value: "1575x1125x1370 mm" },
            { key: "Poids, prêt à fonctionner", value: "650 kg" },
          ]}
        ],
      },
      {
        id: 4,
        name: "Roots Sweep RD160",
        description: "",
        descriptionPoints: [
          { description: "Idéal pour les applications industrielles lourdes." },
          { description: "Grande trémie pour un balayage prolongé." },
          {
            description:
              "Grande surface de filtre efficace pour une absorption efficace et continue de la poussière",
          },
          {
            description:
              "Trajectoire de balayage plus large, productivité maximale",
          },
          {
            description:
              "Construction robuste parfaitement adaptée aux terrains difficiles.",
          },
          {
            description:
              "Balayage efficace de la saleté, de la poussière, des copeaux de métal, des boulons, du bois et autres.",
          },
          {
            description:
              "Lampes frontales pour un fonctionnement sûr dans les zones peu éclairées",
          },
          {
            description:
              "Système hydraulique haute performance pour le fonctionnement de la machine et la conduite.",
          },
          {
            description:
              "Le rétroviseur, le klaxon de marche arrière et les feux arrière sont montés en accessoire standard pour le confort et la sécurité de l'opérateur.",
          },
          { description: "La cabine conducteur est disponible en option." },
          { description: "Moteur diesel économe en carburant éprouvé." },
          { description: "Système compact de débris." },
        ],
        image: require("../assets/images/netoyage/rd160.webp"),
        images: [
          {
            image: require("../assets/images/netoyage/rd160.webp"),
          },
          {
            image: require("../assets/images/netoyage/rd160-2.webp"),
          },
        ],
        video: "https://www.youtube.com/embed/p2nCkPeWgG8", //NOTE: l vid lezmek tekhdou mel youtube => iframe
        ficheTechnique: [
          { key: "Longueur sans balai latéral", value: "2640 millimètres" },
          { key: "Largeur sans balai latéral", value: "1580 millimètres" },
          { key: "Hauteur (jusqu'à la canopée)", value: "2320 millimètres" },
        ],
        brochure: require("../assets/brochure/rb100.pdf"),
        technicalFeatures: [
          {
            id: 1,
            type: "Spécifications",
            features:[
              { key: "Longueur sans balai latéral", value: "2640 millimètres" },
              { key: "Largeur sans balai latéral", value: "1580 millimètres" },
              { key: "Hauteur (jusqu'à la canopée)", value: "2320 millimètres" },
              { key: "Poids mort", value: "1865 kg" },
              {
                key: "Largeur de balayage avec un balai latéral",
                value: "1650 mm",
              },
              {
                key: "Performances de balayage théoriques",
                value: "17325 m²/h à 10,5 km/h",
              },
              { key: "Graduabilité", value: "20%" },
              { key: "Zone de filtrage", value: "12 m²" },
              {
                key: "Longueur du balai principal / Dia",
                value: "1220 / 360 millimètres",
              },
              { key: "Diamètre du balai latéral", value: "660 mm" },
              { key: "Volume de la trémie", value: "640 L" },
              { key: "Hauteur de vidage", value: "1400 mm" },
              { key: "Taper", value: "Mahindra 275TU-Diesel" },
              { key: "Cylindrée", value: "1892/3" },
              { key: "Puissance nominale", value: "28.7KW/39 CV" },
            ]}

        ],
      },
      {
        id: 5,
        name: "Autre balayeuse",
        description: "",
        descriptionPoints: [{ description: "" }],
        image: require("../assets/images/netoyage/autrebalayeuse.webp"),
        images: [
          {
            image: require("../assets/images/netoyage/autrebalayeuse.webp"),
          },
          {
            image: require("../assets/images/netoyage/M40.webp"),
          },
          {
            image: require("../assets/images/netoyage/truck.webp"),
          },
          {
            image: require("../assets/images/netoyage/d1200.webp"),
          },
          {
            image: require("../assets/images/netoyage/r980.webp"),
          },
        ],
        video: "https://www.youtube.com/embed/6CcQZtcqk1A", //NOTE: l vid lezmek tekhdou mel youtube => iframe
        ficheTechnique: [
          { key: "Balayeuse a marche derriére", value: "" },
          { key: "Balade en balayeuse", value: "" },
          { key: "BALAYEUSE MONTÉE SUR CAMION", value: "" },
          { key: "BALAYEUSE DE VILLE", value: "" },
        ],
        brochure: require("../assets/brochure/rb100.pdf"),
        technicalFeatures: [],
      },
    ],
  },
  {
    id: 2,
    image: require("../assets/images/netoyage/wizzard.webp"),
    title: "Laveur",
    products: [
      {
        id: 1,
        name: "Scrub Wizzard - Batterie",
        description: "",
        descriptionPoints: [
          {
            description:
              "ROOTS Scrub wizzard effectue diverses tâches comme laver, essuyer, frotter, sécher en une seule fois.",
          },
          { description: "Il convient à différents types de sols." },
          {
            description:
              "Le sol est prêt à marcher en une minute après l'utilisation.",
          },
          { description: "Batterie sans entretien." },
        ],
        image: require("../assets/images/netoyage/wizzard.webp"),
        images: [
          {
            image: require("../assets/images/netoyage/wizzard.webp"),
          },
          {
            image: require("../assets/images/netoyage/wizzard-2.webp"),
          },
        ],
        video: "", //NOTE: l vid lezmek tekhdou mel youtube => iframe
        ficheTechnique: [
          { key: "Largeur de récurage", value: "315 mm" },
          { key: "Zone de couverture théorique", value: "350 m²/h" },
          { key: "Évaluation de la batterie", value: "24/10V/Hz" },
        ],
        brochure: require("../assets/brochure/scrub-wizard.pdf"),
        technicalFeatures: [
          {
            id: 1,
            type: "Spécifications",
            features:[
            { key: "Largeur de récurage", value: "315 mm" },
            { key: "Zone de couverture théorique", value: "350 m²/h" },
            { key: "Évaluation de la batterie", value: "24/10V/Hz" },
            { key: "Pouvoir total", value: "300W" },
            { key: "Vitesse de la brosse", value: "400 tr/min" },
            { key: "Réservoir d'eau douce", value: "4L" },
            { key: "Réservoir d'eau sale", value: "1.7L" },
            { key: "Dimensions(L*W*H)", value: "378*440*1114 mm" },
            { key: "Masse", value: "25 Kg" },]}

        ],
      },
      {
        id: 2,
        name: "Roots Scrub HD 430 Plus",
        description: "",
        descriptionPoints: [
          {
            description:
              "Machine à disque unique robuste pour le récurage, le polissage et le décapage.",
          },
          {
            description:
              "La conception unique, combinée à sa robustesse en fait une machine préférée pour vos besoins de nettoyage.",
          },
          {
            description:
              "Moteur robuste pour des performances et une efficacité élevées.",
          },
          {
            description:
              "Variété de tampons pour s'adapter à différents types de tâches de nettoyage.",
          },
          {
            description:
              "Interrupteur de sécurité pour éviter tout démarrage accidentel de la machine.",
          },
          {
            description:
              "Support de câble intégré pour ranger le câble lorsqu'il n'est pas utilisé",
          },
          { description: "Poignée réglable facile à utiliser." },
          { description: "Roues non marquantes pour un transport facile." },
        ],
        image: require("../assets/images/netoyage/hd430.webp"),
        images: [
          {
            image: require("../assets/images/netoyage/hd430.webp"),
          },
          {
            image: require("../assets/images/netoyage/hd430-2.webp"),
          },
        ],
        video: "", //NOTE: l vid lezmek tekhdou mel youtube => iframe
        ficheTechnique: [
          { key: "Largeur de récurage", value: "430 mm" },
          { key: "Puissance du moteur", value: "1.5 cv" },
          { key: "Source de courant", value: "230/50 V/Hz" },
        ],
        brochure: require("../assets/brochure/hd430.pdf"),
        technicalFeatures: [
          {
            id: 1,
            type: "Spécifications",
            features:[
              { key: "Largeur de récurage", value: "430 mm" },
              { key: "Puissance du moteur", value: "1.5 cv" },
              { key: "Source de courant", value: "230/50 V/Hz" },
              { key: "Vitesse de brosse", value: "165 tr/min" },
              { key: "Réservoir de solution", value: "10 L" },
              { key: "Longueur de câble", value: "15 m" },
              { key: "Masse", value: "46 Kg" },
            ]}
        ],
      },
      {
        id: 3,
        name: "Roots Scrub E4043",
        description:
          "E4043, la toute nouvelle autolaveuse accompagnée est un mélange parfait de performance, de facilité d'utilisation et de technologie. E4043 offre la flexibilité et la maniabilité et vise à un nettoyage efficace à chaque fois. La capacité améliorée du réservoir offre un fonctionnement plus long et ininterrompu. Conçu pour les applications exigeantes et de nettoyage.E 4043 est la machine idéale pour les clients recherchant une combinaison de performances, de maniabilité et de prix abordable.",
        descriptionPoints: [
          { description: "Conception ergonomique - confortable à utiliser." },
          {
            description:
              "Capacité du réservoir améliorée - Assure des heures de travail plus longues et ininterrompues. Système de freinage - tourner en toute simplicité.",
          },
          {
            description:
              "Protection contre les collisions, les rouleaux déflecteurs assurent la protection de la machine",
          },
          {
            description:
              "Le contrôleur d'égouttement évite les déversements d'eau sur le sol depuis la raclette après avoir éteint le moteur d'aspiration.",
          },
          {
            description:
              "De grands réservoirs de 40 litres assurent un fonctionnement prolongé",
          },
          {
            description:
              "Aqua Stop System agit pour réduire l'essorage de l'eau du pont de la brosse, assurant ainsi d'excellentes performances de nettoyage et permettant d'économiser de l'eau et du détergent.",
          },
          {
            description:
              "Machine idéale pour les centres commerciaux, les bureaux d'entreprise, les hôpitaux, les établissements d'enseignement, les stations de métro, les lieux de culte, etc.",
          },
        ],
        image: require("../assets/images/netoyage/e4043.webp"),
        images: [
          {
            image: require("../assets/images/netoyage/e4043.webp"),
          },
          {
            image: require("../assets/images/netoyage/e4043-2.webp"),
          },
        ],
        video: "https://www.youtube.com/embed/57oSZHY_rGQ", //NOTE: l vid lezmek tekhdou mel youtube => iframe
        ficheTechnique: [
          { key: "Largeur de récurage", value: "430 mm" },
          { key: "Largeur d'aspiration", value: "750 mm" },
          { key: "Zone de couverture", value: "1720 m2 / h" },
        ],
        brochure: require("../assets/brochure/e4043.pdf"),
        technicalFeatures: [
          {
            id: 1,
            type: "Spécifications",
            features:[
              { key: "Largeur de récurage", value: "430 mm" },
              { key: "Largeur d'aspiration", value: "750 mm" },
              { key: "Zone de couverture", value: "1720 m2 / h" },
              { key: "Nb de brosses", value: "1 Nos." },
              { key: "Diamètre de brosse", value: "430 mm" },
              { key: "Vitesse de la brosse", value: "280 tr/min" },
              { key: "Charge de brosse", value: "22 Kg" },
              { key: "Vitesse de travail", value: "4 km/h" },
              { key: "Source de courant", value: "230V E-AC" },
              { key: "Flux d'air", value: "28 L/s" },
              { key: "Pression du vide", value: "1050 mm d' H2O" },
              { key: "Moteur d'aspiration", value: "400W" },
              { key: "Moteur à brosse", value: "800W" },
              { key: "Réservoir d'eau douce", value: "40L" },
              { key: "Réservoir d'eau sale", value: "40L" },
              { key: "Niveau de bruit", value: "73,5 dbA" },
            ]}

        ],
      },
      {
        id: 4,
        name: "Norme RB 650 / 750 / 850",
        description: "",
        descriptionPoints: [
          {
            description:
              "Les RB 650/750/850 sont des machines aux dimensions compactes - Maniabilité parfaite.",
          },
          {
            description:
              "Une vitesse de travail optimale assure une productivité maximale.",
          },
          {
            description:
              "Roues en caoutchouc antidérapantes non marquantes avec système de frein à pied - (tournage facilité).",
          },
          {
            description:
              "Option de pression de brosse supplémentaire - pour un nettoyage facile des sols sales lors de vos déplacements.",
          },
          {
            description:
              "De puissantes batteries de 200 Ah permettent à la machine de fonctionner pendant de plus longues heures.",
          },
          {
            description:
              "Réservoir d'eau sale antibactérien intégré - sans danger pour l'opérateur, le plus adapté même aux établissements de soins de santé.",
          },
          {
            description:
              "La raclette en V avec double mouvement d'oscillation permet une excellente récupération de l'eau et un séchage plus rapide des sols.",
          },
          {
            description:
              "Grand pot verseur d'eau - facile à remplir le réservoir d'eau douce à la fois par le tuyau et le seau.",
          },
          {
            description: "Pente jusqu'à 11% - Escalader les rampes est facile",
          },
          {
            description:
              "Conception ergonomique - siège opérateur confortable avec dossier.",
          },
          {
            description:
              "Machine compacte – facile à transporter même par des ascenseurs.",
          },
          { description: "Commutateur de commande de direction réglable." },
          {
            description:
              "Fonctionnement facile et simple du levier pour l'abaissement et le levage de la brosse/raclette",
          },
          { description: "Contrôle du débit d'eau réglable" },
          {
            description:
              "Fonction de sécurité intégrée - Réduction automatique de la vitesse en tournant",
          },
          {
            description:
              "Caractéristiques de sécurité supplémentaires - Freins de stationnement, interrupteur d'urgence pour un fonctionnement sûr et sécurisé.",
          },
        ],
        image: require("../assets/images/netoyage/rb650.webp"),
        images: [
          {
            image: require("../assets/images/netoyage/rb650.webp"),
          },
          {
            image: require("../assets/images/netoyage/rb650-2.webp"),
          },
        ],
        video: "https://www.youtube.com/embed/A-Hv8eRwT_M", //NOTE: l vid lezmek tekhdou mel youtube => iframe
        ficheTechnique: [
          { key: "Largeur de laveur", value: "650 mm" },
          { key: "Largeur d'aspiration", value: "870 mm" },
          { key: "Zone de couverture théorique", value: "4225 m2/h" },
        ],
        brochure: require("../assets/brochure/rb650.pdf"),
        technicalFeatures: [
          {
            id: 1,
            type: "Spécifications",
            features:[
              { key: "Largeur de laveur", value: "650 mm" },
              { key: "Largeur d'aspiration", value: "870 mm" },
              { key: "Zone de couverture théorique", value: "4225 m2/h" },
              { key: "Vitesse de travail", value: "6.5 km/h" },
              { key: "vitesse de voyage", value: "7km/h" },
              { key: "source de courant", value: "24/200 V/Ah" },
              { key: "Pouvoir total", value: "1600W" },
              { key: "nbre de brosses", value: "2" },
              { key: "diamètre de brosse", value: "333mm" },
              { key: "Vitesse de brosse", value: "180 tr/min" },
              { key: "Charge de brosse", value: "25 Kg" },
              { key: "Réservoir d'eau douce", value: "100L" },
              { key: "Réservoir d'eau sale", value: "100L" },
              {
                key: "Dimension avec raclette",
                value: "1525 x 870 x 1520 (L x l x H mm)",
              },
              { key: "Poids total à vide /avec batterie", value: "220 / 350 Kg" },
              { key: "Poids total prêt à fonctionner", value: "450 Kg" },
              { key: "Cercle de braquage", value: "1250 mm" },
              { key: "Pente", value: "11%" },
            ]}
        ],
      },
      {
        id: 5,
        name: "Autre laveurs",
        description: "",
        descriptionPoints: [],
        image: require("../assets/images/netoyage/laveurs.webp"),
        images: [
          {
            image: require("../assets/images/netoyage/e650.webp"),
          },
          {
            image: require("../assets/images/netoyage/high.webp"),
          },
          {
            image: require("../assets/images/netoyage/rb950.webp"),
          },
        ],
        video: "https://www.youtube.com/embed/A-Hv8eRwT_M", //NOTE: l vid lezmek tekhdou mel youtube => iframe
        ficheTechnique: [
          { key: "Mini - Laveurs", value: "" },
          { key: "Mini Laveurs de sol", value: "" },
          { key: "Machines a disque unique", value: "" },
          { key: "Auto laveuses - Autoportées", value: "" },
        ],
        brochure: require("../assets/brochure/rb650.pdf"),
        technicalFeatures: [],
      },
    ],
  },
];
